<cx-message class='test' *transloco="let t">
  <cx-message-title class="text-center">{{ t(reason) }}</cx-message-title>
  <cx-message-image class="mt-ml"
    [imageSrc]="'assets/images/no-permission-page/no-permission-page-illustration.svg'">
  </cx-message-image>
  <cx-message-text>
    <div class="text-center font-l">{{ t('We couldn\'t complete your login.') }} {{ t('Please try again later.') }}</div>
    <div class="text-center font-l pb-ml">
      {{ t('If you wish to report this issue, please contact our support team.') }}
      <a href="mailto:replenishment-support@bbraun.com" class="link"
        data-cy="replenishment-support-email-link">replenishment-support&#64;bbraun.com</a>
    </div>
  </cx-message-text>
</cx-message>
